import {Component, computed, inject, input} from '@angular/core';
import {CardModule} from 'primeng/card';
import {ToastModule} from 'primeng/toast';
import {rxResource} from '@angular/core/rxjs-interop';
import {catchError, of} from 'rxjs';
import {LoadingComponent} from '../../../../../../shared/components/loading/loading.component';
import {PreviousStepIncompleteNoticeComponent} from '../../../../../../shared/components/previous-step-incomplete-notice/previous-step-incomplete-notice.component';
import {ProjectStepBaseReactive} from '../../../project-base-step/project-base-step-reactive.component';
import {StepDotMenuComponent} from '../../../../../../shared/components/step-dot-menu/step-dot-menu.component';
import {ContractParametersService} from './contract-parameters.service';
import {CardTitleComponent} from '../../../../../../shared/components/header/card-title/card-title.component';
import {
  ContractParametersContainerResponse,
  ProjectChapterType,
  ProjectRoleType,
  ProjectStepType,
} from '@frontend/shared';
import {ProposalParameterPanelsComponent} from './components/contract-parameter-panels/proposal-parameter-panels.component';

const INITIAL_CONTRACT_CONTAINER: ContractParametersContainerResponse = {
  contractParameters: {
    contractTotalTerms: 0,
    terminationPeriod: 0,
    solutionType: '',
    implementationMethod: '',
    licenseModel: '',
    paymentTerm: '',
    languages: [],
  },
  implementationTimelines: [],
};

@Component({
  imports: [
    CardModule,
    ToastModule,
    LoadingComponent,
    PreviousStepIncompleteNoticeComponent,
    StepDotMenuComponent,
    ProposalParameterPanelsComponent,
    CardTitleComponent,
  ],
  templateUrl: './step-8-1-rfq-proposal-parameter.component.html',
})
export class Step81RfqProposalParameterComponent extends ProjectStepBaseReactive {
  private readonly contractParametersService = inject(ContractParametersService);

  readonly isReadOnly = input<boolean>(false);

  protected readonly stepPrerequisiteCompleted = computed(() =>
    this.stepState.areStepsCompleted([
      {
        chapterId: ProjectChapterType.ACTUAL_SYSTEMS,
        stepId: ProjectStepType.SYSTEM_INTEGRATION_CONFIG,
      },
    ]),
  );

  readonly contractParametersResource = rxResource({
    params: () => ({
      projectId: this.projectId(),
      isReady: this.stepPrerequisiteCompleted(),
    }),
    stream: ({params: request}) => {
      if (request.projectId === undefined || !request.isReady) {
        return of(INITIAL_CONTRACT_CONTAINER);
      }
      return this.contractParametersService.loadContractParametersContainer(request.projectId).pipe(
        catchError((err) => {
          console.error('Initial load of contract parameters failed:', err);
          return of(INITIAL_CONTRACT_CONTAINER);
        }),
      );
    },
  });

  readonly contractParametersContainer = computed(
    () => this.contractParametersResource.value() ?? INITIAL_CONTRACT_CONTAINER,
  );

  protected async onSaved(): Promise<void> {
    await this.stepState.loadStepStatuses(this.projectId()!);
    this.contractParametersResource.reload();
  }

  protected readonly ProjectStepType = ProjectStepType;
  protected readonly ProjectRoleType = ProjectRoleType;
}
